import { Component, inject, Input } from '@angular/core';
import { BillingUtilsService } from 'src/app/billing/services/billing-utils.service';
import { RvBadgeColor } from 'src/app/components/rv-badge/rv-badge.component';

@Component({
  selector: 'status-name',
  templateUrl: './status-name.component.html',
  styleUrls: ['./status-name.component.scss'],
  standalone: false,
})
export class StatusNameComponent {
  @Input() subscription;

  readonly billingUtils = inject(BillingUtilsService);

  get badgeColor(): RvBadgeColor {
    if (
      this.billingUtils.isActive(this.subscription) ||
      this.billingUtils.isTrial(this.subscription)
    ) {
      return 'green';
    }

    if (
      this.billingUtils.isPaused(this.subscription) ||
      this.billingUtils.isCancelled(this.subscription)
    ) {
      return 'red';
    }

    return 'gray';
  }

  get statusText(): string {
    if (this.subscription.status === 'non_renewing') {
      return 'active';
    }

    if (this.subscription.status === 'in_trial') {
      return 'trial';
    }

    return this.subscription.status;
  }
}
